import React, { useState, useRef } from 'react';
import DynamicKakaoMapSelectContainer from './DynamicKakaoMapSelectContainer';
import useAuthStore from '../../store/authStore';

const SelfPlaceContainer = ({ onPlaceSelect }) => {
    const { member } = useAuthStore();
    const [placeName, setPlaceName] = useState('');
    const [placeAddress, setPlaceAddress] = useState('');
    const mapRef = useRef(null);

    const handleComplete = () => {
        if (!placeName.trim()) {
            alert('장소명을 입력해주세요.');
            return;
        }

        if (!placeAddress.trim()) {
            alert('주소를 입력해주세요.');
            return;
        }

        // 버튼 클릭 시점에 현재 지도 좌표 가져오기
        const currentPosition = mapRef.current?.getCurrentPosition() || {
            latitude: member?.latitude,
            longitude: member?.longitude
        };

        const selectedPlace = {
            name: placeName.trim(),
            address: placeAddress.trim(),
            phone: null,
            latitude: currentPosition.latitude,
            longitude: currentPosition.longitude,
            isPartner: false,
            partnerId: null
        };

        console.log('선택된 장소:', selectedPlace);
        if (onPlaceSelect) {
            onPlaceSelect(selectedPlace);
        }
    };

    const isFormValid = placeName.trim() && placeAddress.trim();

    return (
        <div className="flex flex-col h-full">
            {/* 지도 컨테이너 */}
            <div className=" p-3 rounded-lg">
                <p className="text-md text-gray-700">
                    지도를 움직여서 장소를 선택해주세요.
                </p>
            </div>
            <div className="mx-4 mt-4 mb-2 aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden">
                <DynamicKakaoMapSelectContainer
                    ref={mapRef}
                    className="w-full h-full"
                />
            </div>

            {/* 입력 필드 */}
            <div className="flex-1 bg-white rounded-t-2xl p-4 space-y-6">
                {/* 장소명 */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        장소명 <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="장소명을 입력해주세요 (최대 30자)"
                        value={placeName}
                        onChange={(e) => setPlaceName(e.target.value)}
                        maxLength={30}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                    />
                    <p className="text-xs text-gray-500 text-right mt-1">{placeName.length}/30</p>
                </div>

                {/* 주소 */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        주소 <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        placeholder="주소를 입력해주세요 (최대 100자)"
                        value={placeAddress}
                        onChange={(e) => setPlaceAddress(e.target.value)}
                        maxLength={100}
                        rows={3}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 resize-none"
                    />
                    <p className="text-xs text-gray-500 text-right mt-1">{placeAddress.length}/100</p>
                </div>
            </div>

            {/* 하단 버튼 */}
            <div className="p-4 bg-white border-t border-gray-200">
                <button
                    onClick={handleComplete}
                    disabled={!isFormValid}
                    className={`w-full py-4 rounded-lg font-medium transition-colors ${
                        isFormValid
                            ? 'bg-amber-500 text-white active:bg-amber-600'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                >
                    장소 선택 완료
                </button>
            </div>
        </div>
    );
};

export default SelfPlaceContainer;
